const jumpHref = {
    // 我的新赛事
    rating2: {
        // 赛事活动详情页
        detail: id => {
            return `/rating2/rating/detail/${id}`;
        },
        // 赛事活动详情页
        matchRatingDetail: (id, params) => {
            const searchParams = new URLSearchParams({...params}).toString()
            return `/match/rating/detail/${id}?${searchParams}`;
        },
        // 赛事评审列表页
        ratingList: id => {
            return `/rating2/expert/rating/list/${id}?from=site`;
        },
        // 赛事评分页
        ratingExpert2: () => {
            return '/match/mycompetition?tab=score&type=2'
        },
        matchReview: (id, type) => {
            return `/match/expert/rating/list/${id}?type=${type}`
        }
    },
    // 我的赛事详情页
    fruit: {
        detail: id => {
            return `/rating/activity/${id}/detail`;
        },
    },

    // 协作组相关地址
    group: {
        create: authUrl => {
            return '/group/edit';
        },
        detail: (groupId, authUrl) => {
            return `/group/${groupId}/detail`;
        },
        detail2: (groupId, authUrl) => {
            return `/group2/${groupId}/detail`;
        }
    },

    // 资源相关地址
    resource: {
        detail: (sourceId, resourceFrom = '') => {
            return `/resource/detail?sourceId=${sourceId}&resourceFrom=${resourceFrom}`;
        },
    },

    // 活动
    activity: {
        detail: activityId => {
            return `/ac2/activity/${activityId}/detail`;
        },
        create: (bizType = 'xicheng') => {
            return `/ac2/activity/0/edit?bizType=${bizType}`;
        },
    },

    // 管理中心
    idxmc: {
        index: () => {
            return '/idxmc/home';
        },
    },
    // 新管理中心（包含科研）
    smc: {
        index: () => {
            return '/smc/home';
        },
    },
    // // 课程
    // course: {
    //     detail: (courseId) => {
    //         return `/idx/course/details?courseId=${courseId}`;
    //     }
    // },
    // 视频案例
    videocase: {
        create: () => {
            return '/eoc/createCase?from=square';
        },
        edit: lessonId => {
            return `/eoc/editCase?lessonId=${lessonId}&from=square`;
        },
        detail: lessonId => {
            return `/eoc/case/detail/${lessonId}`;
        },
    },
    // 听评课
    lesson: {
        create: () => {
            return '/eoc/createCourse?from=square';
        },
        detail: lessonId => {
            return `/eoc/detail/${lessonId}`;
        },
    },
    // 慕课
    mooc: {
        create: tabStr => {
            // 慕课创建
            return `/mooc/course/create?tabStr=${tabStr}`;
        },
        edit: (moocId, tabStr) => {
            // 慕课编辑
            return `/mooc/course/${moocId}/edit?tabStr=${tabStr}`;
        },
        manage: (moocId, tabStr) => {
            // 慕课
            return `/mooc/manage/${moocId}/detail?tabStr=${tabStr}`;
        },
        detail: moocId => {
            return `/mooc/course/${moocId}/detail`;
        },
        topicDetail: moocId => {
            // 慕课专题详情
            return `/mooc/topic/${moocId}/detail`;
        },
        courseCreate: tabStr => {
            // 课程素材创建
            return `/mooc/design?tabStr=${tabStr}`;
        },
        courseEdit: (courseId, tabStr) => {
            // 课程素材编辑
            return `/mooc/design/${courseId}/edit?step=1&type=1&tabStr=${tabStr}`;
        },
        courseDesign: (courseId, tabStr) => {
            return `/mooc/design/${courseId}/edit?step=2&type=1&tabStr=${tabStr}`;
        },
        courseDetail: courseId => {
            return `/mooc/design/${courseId}/detail`;
        },
        catalogueDetail: (moocId, catalogueId, courseId) => {
            return `/mooc/catalogue/${moocId}/detail?catalogueId=${catalogueId}&courseId=${courseId}`;
        },
    },
    // 测验跳转问卷相关地址
    questionMoocTest: {
        // 管理问卷题目页面
        create: (id, bizType, queryParams = '') => {
            // 问卷id 业务类型
            return `/qc/questionnare/${id}/manage?subBizType=mooc_assess${queryParams}`;
        },
        // 查看问卷题目页面
        detail: (id, queryParams = '') => {
            // 问卷id 业务类型
            return `/qc/questionnare/${id}/detail?subBizType=mooc_assess${queryParams}`;
        },
        answer: (id, subBizId, queryParams = '') => {
            return `/qc/questionnare/${id}/answer?subBizId=${subBizId}&subBizType=mooc_assess${queryParams}`;
        },
        result: (id, subBizId, queryParams = '') => {
            // 问卷结果
            return `/qc/questionnare/${id}/result?subBizId=${subBizId}&subBizType=mooc_assess${queryParams}`;
        },
    },
    home: {
        home: () => {
            return '/idx/home';
        },
        userHomePage: userId => {
            return `/idx/userCenter/userHomePage?uId=${userId}`;
        },
    },
    // 课程
    course: {
        detail: (courseId, from = '') => {
            return `/idx/course/details?from=${from}&courseId=${courseId}`;
        },
    },
    // 培训
    strain: {
        index: () => {
            return '/strain/home';
        },
        courseManage: courseId => {
            return `/strain/creation/course/${courseId}/manage`;
        },
        schoolCourseManage: courseId => {
            return `/strain/school/course/2/${courseId}/manage`;
        },
    },
    buddy: {
        index: () => {
            return '/buddy/home';
        },
        scIndex: () => {
            return '/buddy/custom/home'
        }
    },
    research: {
        create: (backUrl, source) => {
            return `/idx/research/create?backUrl=${backUrl}&source=${source}`;
        },
        subject: () => {
            return '/idx/research/subject';
        },
        detail: (id) => {
            return `/idx/research/subject/detail/${id}`;
        }
    },
    // 任务
    task: {
        detail: taskId => `/qa/task/${taskId}/detail`,
    },
    // 工作室
    studio: {
        // 我的工作室
        myStudio: () => {
            return '/idx/userCenter/studio';
        },
        // 创建工作室
        createStudio: () => {
            return '/studio/create';
        },
        // 工作室详情
        studioDetail: id => {
            return `/studio/detail/${id}`;
        },
        // 简报成果详情
        squareDetail: (squareId, typeString, rowId) => {
            return `/studio/${squareId}/${typeString}/${rowId}/detail`;
        },
        square: '/idx/teachingStudio/square',
        teachingStudioDynamics: (type = '') => {
            if (type === 'result') {
                return '/idx/teachingStudio/square/dynamics/result'
            }
            return '/idx/teachingStudio/square/dynamics';
        }
    },
    // 个人中心
    userCenter: {
        // 我的关注
        myFollow: () => {
            return '/idx/userCenter/follow?tab=followed'
        },
        // 我的进阶
        myAdvance: () => {
            return '/idx/userCenter/advance'
        },
        // 我的成长档案
        myArchives: () => {
            return '/idx/userCenter/archives'
        },
        // 智能推送
        smartPush: () => {
            return '/idx/userCenter/smart-push'
        },
        // 我的成果
        myAchievement: () => {
            return '/idx/userCenter/achievement'
        },
        // 个人信息
        myInfo: () => {
            return '/idx/userCenter/accountInfo'
        },
        // 账号安全
        accountSecurity: () => {
            return '/idx/userCenter/accountSecurity'
        },
        // 我的粉丝
        myFans: () => {
            return '/idx/userCenter/follow?tab=fans'
        },
    },
    // 睿云学伴
    multiBuddy: {
        // 综合画像
        portrait: () => {
            return '/buddy/multi/personal/portrait'
        },
        // 成长路径
        trajectory: () => {
            return '/buddy/multi/personal/trajectory'
        },
        // 进阶分析
        analysis: () => {
            return '/buddy/multi/personal/analysis'
        },
        // 成长档案
        devReport: () => {
            return '/buddy/multi/personal/devReport'
        },
    },
    // 数据驾驶舱
    dashboard: {
        // 管理员端
        admin: () => {
            return '/idx/data-cockpit'
        },
    }
};

const getUrl = (keys, obj = jumpHref) => {
    let keySpre = keys.constructor == Array ? keys : keys.split('.');
    if (!obj[keySpre[0]]) {
        return false;
    }
    if (keySpre.length == 1 && obj[keySpre[0]]) {
        if (typeof obj[keySpre[0]] == 'string') {
            return obj[keySpre[0]];
        }
        return obj[keySpre[0]]();
    }
    let state = getUrl(keySpre.splice(1), obj[keySpre[0]]);
    return state;
};

export { jumpHref };

export { getUrl };
